import './styles.scss';
import React from "react";
import { Link } from 'react-router-dom';
import brandLogo from '../../assets/image.png';

export const LandingPage: React.FC = () => {
  return (
    <div className="landing-wrapper">
      <header className="landing-header">
        <div className="logo">
          <img src={brandLogo} alt="Parking Hero Logo" />
        </div>
        <nav className="auth-buttons">
          <Link to="/signup">Sign Up</Link>
          <Link to="/login">Log In</Link>
        </nav>
      </header>

      <div className="landing-content">
        <main className="landing-main">
          <h1>Prevent Parking Fines, Tickets, and Towing</h1>
          <p>
            Parking Hero is the fastest way to get notified before it’s too late.
            No app download required.
          </p>
          <div className="cta-buttons">
            <Link to="/signup">
              <button>Sign Up Now</button>
            </Link>
          </div>
        </main>
      </div>

      <footer className="landing-footer">
        <p>© 2025 Parking Hero · Built with ❤️ in your neighborhood</p>
      </footer>
    </div>
  );
};